import React from 'react';
import { ReactComponent as Metamask } from '@blink/assets/src/icons/metamask.svg';
import { METAMASK_DOWNLOAD_URL } from '@blink/components/src/constants/global';

import { useHideModal } from '../../hooks';

import { Button, ButtonVariant } from '@/shared/ui';

export const MetamaskNotInstalledModal = () => {
    const { handleCloseModal } = useHideModal();

    const openMetamaskInstall = () => {
        window.open(METAMASK_DOWNLOAD_URL, '_blank', 'noreferrer');
        handleCloseModal();
    };

    return (
        <>
            <div className='min-w-[456px]'>
                <div className='flex mx-auto mb-5 w-[96px] h-[96px]'>
                    <Metamask className='w-[100%] h-[100%]' />
                </div>
                <div className='flex justify-center w-full text-[20px] font-bold'>
                    MetaMask is not installed
                </div>
                <div className='flex justify-center text-center w-full text-[16px] leading-[var(--line-height-sm)] mb-7 text-content-secondary'>
                    The MetaMask extension is not installed in your browser
                </div>
                <div className='w-full mt-7 border-t border-opaque'>
                    <Button
                        variant={ButtonVariant.Primary}
                        className='w-full'
                        onClick={openMetamaskInstall}
                    >
                        Install MetaMask
                    </Button>
                </div>
            </div>
        </>
    );
};
